import { render } from "./ReferalSuccess.vue?vue&type=template&id=e613b57a&scoped=true"
import script from "./ReferalSuccess.vue?vue&type=script&lang=js"
export * from "./ReferalSuccess.vue?vue&type=script&lang=js"

import "./ReferalSuccess.vue?vue&type=style&index=0&id=e613b57a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e613b57a"]])

export default __exports__